var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardImageSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.98,
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 24.625C20.0919 24.625 24.625 20.0919 24.625 14.5C24.625 8.90812 20.0919 4.375 14.5 4.375C8.90812 4.375 4.375 8.90812 4.375 14.5C4.375 20.0919 8.90812 24.625 14.5 24.625ZM14.1432 18.5152L19.7682 11.7652L18.2318 10.4848L13.3078 16.3936L10.7071 13.7929L9.29289 15.2071L12.6679 18.5821L13.4422 19.3564L14.1432 18.5152Z",
    fill: "#12B76A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardImageSelected);
export default __webpack_public_path__ + "static/media/dashboard-image-selected.4be7843d45d6fa0de0abc0d41bb80685.svg";
export { ForwardRef as ReactComponent };